export enum Locale {
    en = "en",
}
